






import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class StickToBottom extends Vue {}
